(() => {
  if (/^\/products\/pflege\/?$/.test(location.pathname)) return;
  const channel = crypto.randomUUID();
  let access;
  const request = async (url, options={}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 45000);
    try {
      const response = await fetch(url, {...options, credentials:'omit', signal:controller.signal});
      if (!response.ok) throw new Error('Die Verbindung ist gerade nicht verfügbar. Bitte versuche es erneut.');
      return await response.json();
    } catch(error) {
      if(error.name==='AbortError') throw new Error('Die Verbindung dauert zu lange. Bitte versuche es erneut.');
      throw error;
    } finally { clearTimeout(timer); }
  };
  window.nbLeadSave = async payload => {
    const endpoint = window.NB_LEAD_ENDPOINT;
    if (!endpoint) throw new Error('Bitte versuche es in Kürze noch einmal.');
    if (!access) {
      access = await request(endpoint+'?transport=json&origin='+encodeURIComponent(location.origin)+'&channel='+channel);
      if(!access.ok || !access.token) {access=null;throw new Error('Bitte lade die Seite neu.');}
    }
    const result = await request(endpoint, {method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({token:access.token,payload})});
    if (!result.ok) {access=null;throw new Error(result.error || 'Die Anmeldung hat nicht geklappt. Bitte versuche es erneut.');}
    return result;
  };
})();

(() => {
  if (/^\/products\/pflege\/?$/.test(location.pathname)) return;
  const modal = document.getElementById('NurseLeadModal');
  if (!modal) return;
  const form = document.getElementById('NurseLeadForm');
  const error = document.getElementById('nb-lead-error');
  const fields = form.elements;
  const pathway = modal.querySelector('.nb-pathway');
  const trigger = modal.querySelector('#nb-pathway-trigger');
  const list = modal.querySelector('#nb-pathway-options');
  const options = [...list.querySelectorAll('[role="option"]')];
  let active = 0, typed = '', typeTimer;
  const highlight = index => {
    active = Math.max(0, Math.min(options.length - 1, index));
    options.forEach((option, i) => option.classList.toggle('is-active', i === active));
    trigger.setAttribute('aria-activedescendant', options[active].id);
    options[active].scrollIntoView({block:'nearest'});
  };
  const closeOptions = () => {
    list.hidden = true; trigger.setAttribute('aria-expanded','false');
    trigger.removeAttribute('aria-activedescendant');
  };
  const openOptions = () => {
    list.hidden = false; trigger.setAttribute('aria-expanded','true');
    highlight(Math.max(0, options.findIndex(option => option.dataset.value === fields.pathway.value)));
  };
  const choose = index => {
    const option = options[index]; fields.pathway.value = option.dataset.value;
    modal.querySelector('#nb-pathway-value').textContent = option.textContent;
    options.forEach(item => item.setAttribute('aria-selected', String(item === option)));
    trigger.removeAttribute('aria-invalid'); error.hidden = true;
    closeOptions(); trigger.focus({preventScroll:true});
  };
  trigger.addEventListener('click', () => list.hidden ? openOptions() : closeOptions());
  options.forEach((option,index) => {
    option.addEventListener('click', () => choose(index));
    option.addEventListener('pointermove', () => { active=index; options.forEach((item,i)=>item.classList.toggle('is-active',i===index)); trigger.setAttribute('aria-activedescendant',option.id); });
  });
  trigger.addEventListener('keydown', event => {
    if (['ArrowDown','ArrowUp','Home','End','Enter',' ','Escape'].includes(event.key)) {
      event.preventDefault(); event.stopPropagation();
      if (event.key === 'Escape') { closeOptions(); return; }
      if (event.key === 'Enter' || event.key === ' ') { list.hidden ? openOptions() : choose(active); return; }
      if (list.hidden) { openOptions(); if(event.key === 'ArrowUp') highlight(options.length-1); }
      else highlight(event.key==='Home'?0:event.key==='End'?options.length-1:active+(event.key==='ArrowDown'?1:-1));
    } else if (event.key === 'Tab') closeOptions();
    else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
      clearTimeout(typeTimer); typed += event.key.toLocaleLowerCase('de');
      if(list.hidden) openOptions();
      const match=options.findIndex(option=>option.textContent.toLocaleLowerCase('de').startsWith(typed));
      if(match>=0) highlight(match); typeTimer=setTimeout(()=>typed='',700);
    }
  });
  modal.addEventListener('pointerdown', event => {if(!pathway.contains(event.target)) closeOptions();});
  modal.addEventListener('close', closeOptions);
  const key = 'nurse_bound_lead_prompt_v1';
  const requestId = crypto.randomUUID();
  let lastFocus, busy = false;
  const remember = (state) => { try { localStorage.setItem(key, JSON.stringify({state, time:Date.now()})); } catch {} };
  const close = () => { modal.close(); remember(form.hidden?'completed':'dismissed'); lastFocus?.focus({preventScroll:true}); };
  const open = (event) => {
    event?.preventDefault(); lastFocus = document.activeElement;
    const drawer = document.getElementById('MenuDrawer');
    if (drawer && !drawer.hidden) drawer.querySelector('.drawer__close')?.click();
    if (!modal.open) modal.showModal();
    (form.hidden ? modal.querySelector('#nb-lead-success a') : fields.email).focus({preventScroll:true});
  };
  document.querySelectorAll('[data-nb-lead-open]').forEach(b => b.addEventListener('click', open));
  modal.querySelectorAll('[data-nb-lead-close]').forEach(b => b.addEventListener('click', close));
  modal.addEventListener('cancel', event => { event.preventDefault(); close(); });
  modal.addEventListener('click', event => { if (event.target === modal) { const r=modal.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) close(); } });
  const phoneValue = () => {
    let v=fields.phone.value.trim().replace(/[\s()./-]/g,'');
    if(v.startsWith('00')) v='+'+v.slice(2);
    else if(v.startsWith('0')) v='+49'+v.slice(1);
    return v;
  };
  const save = async (stage) => {
    if (busy) return false;
    busy=true;error.hidden=true;
    form.querySelectorAll('button').forEach(b=>b.disabled=true);
    try {
      await window.nbLeadSave({request_id:requestId,email:fields.email.value.trim(),pathway:fields.pathway.value,phone:stage==='complete'?phoneValue():'',email_consent:fields.email_consent.checked,sms_consent:stage==='complete'&&fields.sms_consent.checked,website:fields.website.value,stage,source:location.pathname,consent_version:'de-2026-09-20-v1'});
      return true;
    } catch(problem) {error.textContent=problem.message||'Die Anmeldung hat nicht geklappt. Bitte versuche es erneut.';error.hidden=false;return false;}
    finally {busy=false;form.querySelectorAll('button').forEach(b=>b.disabled=false);}
  };
  const finish=async()=>{
    if(!fields.email.reportValidity()) return;
    if(!fields.pathway.value){error.textContent='Bitte wähle deinen Ausbildungsweg aus.';error.hidden=false;trigger.setAttribute('aria-invalid','true');trigger.focus();openOptions();return;}
    const phone=phoneValue();
    if(phone&&!/^\+[1-9]\d{6,14}$/.test(phone)){error.textContent='Bitte gib eine gültige Handynummer mit Ländervorwahl ein, z. B. +49.';error.hidden=false;fields.phone.focus();return;}
    if(fields.sms_consent.checked&&!phone){error.textContent='Für SMS benötigen wir deine Handynummer.';error.hidden=false;fields.phone.focus();return;}
    if(await save('complete')){form.hidden=true;document.getElementById('nb-lead-success').hidden=false;remember('completed');document.querySelector('.nb-lead-teaser').hidden=true;modal.querySelector('#nb-lead-success a').focus();}
  };
  form.addEventListener('submit',event=>{event.preventDefault();finish();});
  let saved=null;try{saved=JSON.parse(localStorage.getItem(key));}catch{}
  if(saved?.state==='completed') document.querySelector('.nb-lead-teaser').hidden=true;
  if(!saved || (saved.state!=='completed' && Date.now()-saved.time>7*86400000)) {
    setTimeout(()=>{if(!modal.open) open();},1200);
  }
  document.querySelectorAll('.nb-nav-dropdown').forEach(details=>{
    details.addEventListener('toggle',()=>{if(details.open) document.querySelectorAll('.nb-nav-dropdown').forEach(other=>{if(other!==details) other.open=false;});});
    details.addEventListener('keydown',e=>{if(e.key==='Escape'){details.open=false;details.querySelector('summary').focus();}});
  });
  document.addEventListener('click',e=>{if(!e.target.closest('.nb-nav-dropdown'))document.querySelectorAll('.nb-nav-dropdown').forEach(d=>d.open=false);});
})();
